import { SiteItemData } from "../../../../interfaces";
import { isWcmEditor } from "config/serverConfig";
import { VideoGalleryVerticalDesktop } from "./videoGalleryVerticalDesktop";
import { LinkTargetProperties } from "../../../../../global/components/linkSettings/interfaces";

export interface categoryObj {
    id: string
    categoryColor: string
    name:string
}

interface VideoGalleryVerticalComponentaProps {
    videoList: SiteItemData[]
    isTabVisible: boolean
    isTitleVisible:boolean
    isSubTitleVisible: boolean
    tabLink: string
    tabLinkTarget: LinkTargetProperties
    tabTitleText: string
    repeatAds: number
    maxAds: number
    firstAdPlace: number
    category: categoryObj
    domain: string
    showPrerollAds: boolean
}

export class CalcalistVideoGalleryVerticalComponenta extends React.Component<VideoGalleryVerticalComponentaProps, {}>{
    public static siteScriptName = "calcalistVideoGalleryVerticalComponenta";

    public render() {
        const { videoList, isTabVisible, tabTitleText, repeatAds, maxAds, firstAdPlace, category, domain, tabLink, tabLinkTarget, isTitleVisible, isSubTitleVisible, showPrerollAds } = this.props;
        const componentClass = `calcalistVideoGalleryVerticalComponenta ${isWcmEditor() ? "editMode" : ""}`;

        return (
            <div className={componentClass}>
                <VideoGalleryVerticalDesktop
                    videoList={videoList}
                    isTabVisible={isTabVisible}
                    tabLink={tabLink}
                    tabLinkTarget={tabLinkTarget}
                    tabTitleText={tabTitleText}
                    repeatAds={repeatAds}
                    maxAds={maxAds}
                    firstAdPlace={firstAdPlace}
                    category={category}
                    domain={domain}
                    isTitleVisible={isTitleVisible}
                    isSubTitleVisible={isSubTitleVisible}
                    showPrerollAds={showPrerollAds}/>
            </div>
        )
    }
}